import React from 'react';

interface UserDeleteConfirmationProps {
  user: {
    userId: string;
    role: string;
    isEnabled: boolean;
  } | null;
  onConfirm: () => void;
  onCancel: () => void;
  isOpen: boolean;
}

const UserDeleteConfirmation: React.FC<UserDeleteConfirmationProps> = ({
  user,
  onConfirm,
  onCancel,
  isOpen
}) => {
  if (!isOpen || !user) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-md w-full">
        <div className="flex items-center mb-4">
          <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
            <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 18.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
        </div>
        
        <div className="text-center">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Delete User</h3>
          <div className="mb-4">
            <p className="text-sm text-gray-500 mb-2">
              Are you sure you want to delete user <strong>{user.userId}</strong>?
            </p>
            <div className="bg-red-50 border border-red-200 rounded-md p-3 text-left">
              <h4 className="text-sm font-medium text-red-800 mb-2">This action will:</h4>
              <ul className="text-sm text-red-700 space-y-1">
                <li>• Remove user from Cognito User Pool</li>
                <li>• Delete all user data from database</li>
                <li>• Remove all bucket permissions</li>
                <li>• Clear activity logs (after retention period)</li>
              </ul>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              <strong>This action cannot be undone.</strong> Consider disabling the user instead.
            </p>
          </div>
        </div>
        
        <div className="flex justify-center space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700"
          >
            Delete User
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserDeleteConfirmation;